<template>
  <div>
    <h2 class="mb-4">
      Call Logs
    </h2>
    <div class="col-12 col-sm-6 mb-5">
      <CForm>
        <CFormGroup class="form-group form-row">
          <template #label>
            <slot name="label">
              <label class="col-form-label col-sm-3">
                Date Range
              </label>
            </slot>
          </template>

          <template #input>
            <date-range-picker
              v-model="dateRange"
              opens="right"
              class="col-sm-6 col-lg-5 col-12"
              :locale-data="{ firstDay: 1, format: 'mediumDate' }"
              :min-date="minDate"
              :max-date="maxDate"
              @update="searchCalls"
            >
              <template #input>
                {{ formatDate(selectedDateFrom) }} - {{ formatDate(selectedDateTo) }}
              </template>
            </date-range-picker>
          </template>
        </CFormGroup>

        <CTextarea
          v-model="callerIds"
          label="Caller Ids"
          placeholder="Enter comma separated or new line separated caller Ids"
          horizontal
          rows="3"
        />

        <CTextarea
          v-model="callIds"
          label="Call Ids"
          placeholder="Enter comma separated or new line separated call Ids"
          horizontal
          rows="3"
        />

        <div class="form-row">
          <CCol
            :md="{ offset: '3', size: '9' }"
            :sm="{ offset: '3', size: '9' }"
          >
            <ButtonLoading
              type="button"
              color="success"
              :loading="loading"
              @click="searchCalls"
            >
              <CIcon
                name="cil-search"
                class="mr-2"
              />Search
            </ButtonLoading>

            <div
              v-if="invalidFilters"
              class="invalid-feedback d-flex mt-2"
            >
              <CIcon
                name="cilWarning"
                class="mr-1"
              />
              Please enter at least 1 caller Id or call Id.
            </div>
          </CCol>
        </div>
      </CForm>
    </div>

    <CallsList
      :calls="calls"
      :loading="loading"
      :date-from="selectedDateFromInDateFormat"
      :date-to="selectedDateToInDateFormat"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

import { showErrorMessage } from '@/notification-utils'
import formGenericMixin from '@/mixins/form-generic-mixin'
import CallsList from './CallsList.vue'
import { 
  formatDate,
} from '@/utils'

const MAX_DATE_RANGE = 120

export default {
  name: 'CallLogs',

  title: 'Call Logs',

  components: {
    CallsList,
  },

  mixins: [formGenericMixin],

  data() {
    return {
      minDate: moment().subtract(6, 'months').startOf('month').toDate(),
      maxDate: moment().endOf('day').toDate(),
    }
  },

  computed: {
    ...mapState('callLogs', [
      'searchForCallIds',
      'searchForCallerIds',
      'dateFrom',
      'dateTo',
      'calls'
    ]),

    ...mapState('callLogs', {
      loading: state => state.isLoading
    }),

    invalidFilters() {
      return this.submitted && !this.callIds?.trim() && !this.callerIds?.trim()
    },

    dateRange: {
      get() {
        return {
          startDate: this.selectedDateFrom,
          endDate: this.selectedDateTo
        }
      },
      set({ startDate, endDate }) {
        if (endDate - startDate > this.daysToMilliseconds(MAX_DATE_RANGE)){
          showErrorMessage(`Time range cannot be longer than ${MAX_DATE_RANGE} days`)
          return
        }

        this.selectedDateFrom = moment(startDate).startOf('day').toDate()
        this.selectedDateTo = moment(endDate).endOf('day').toDate()
      }
    },

    selectedDateFrom: {
      get() {
        return this.dateFrom
      },
      set(value) {
        this.SET_DATE_FROM(value)
      }
    },

    selectedDateTo: {
      get() {
        return this.dateTo
      },
      set(value) {
        this.SET_DATE_TO(value)
      }
    },

    selectedDateFromInDateFormat() {
      return moment(this.selectedDateFrom).format('YYYY-MM-DD')
    },

    selectedDateToInDateFormat() {
      return moment(this.selectedDateTo).format('YYYY-MM-DD')
    },

    callerIds: {
      get() {
        return this.searchForCallerIds
      },
      set(value) {
        this.SET_CALLER_IDS(value)
      }
    },

    callIds: {
      get() {
        return this.searchForCallIds
      },
      set(value) {
        this.SET_CALL_IDS(value)
      }
    }
  },

  methods: {
    ...mapActions('callLogs', [
      'searchForCalls'
    ]),

    ...mapMutations('callLogs', [
      'SET_DATE_FROM',
      'SET_DATE_TO',
      'SET_CALL_IDS',
      'SET_CALLER_IDS',
    ]),

    formatDate,

    async searchCalls() {
      this.submitted = true

      if (this.callIds?.trim() || this.callerIds?.trim()) {
        await this.searchForCalls()
      }
    },

    daysToMilliseconds(days) {
      return days * 24 * 60 * 60 * 1000
    }
  },
}
</script>
<style lang="scss" scoped></style>